import styled, { css } from "styled-components";
import { colors, fonts } from "../../../styles/variables";
import { inputStyles } from "../Input";
import breakpoints from "../../../styles/breakpoints";

export const dateInputStyles = css`
  font-size: 12px !important;
  font-family: ${fonts.fontBauMedium} !important;
  ::-webkit-input-placeholder {
    color: ${colors.black};
    font-family: ${fonts.fontBauMedium};
    opacity: 1;
  }
  ::-moz-placeholder {
    color: ${colors.black};
    font-family: ${fonts.fontBauMedium};
    opacity: 1;
  }
  :-ms-input-placeholder {
    color: ${colors.black};
    font-family: ${fonts.fontBauMedium};
    opacity: 1;
  }
  :-moz-placeholder {
    color: ${colors.black};
    font-family: ${fonts.fontBauMedium};
    opacity: 1;
  }
`;

export const DatePickerHolder = styled.div`
  position: relative;

  input {
    ${inputStyles};
    padding-right: 45px;
    ${dateInputStyles};
  }
`;

export const AliasDatePickerHolder = styled(DatePickerHolder)`
  position: relative;
`;

export const DatePickerIconHolder = styled.div`
  border-left: 1px solid ${colors.black};
  position: absolute;
  right: 0;
  top: 0;
  height: 100%;
  width: 40px;
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const DatePickerIcon = styled.img`
  width: 20px;
`;

export const InputErrorBox = styled.div`
  padding: 10px 15px;
  background-color: ${colors.danger};
  color: ${colors.white};
  margin-bottom: 10px;

  &:empty {
    display: none;
  }
`;

export const DateInput = styled.input<{ hasLabelTop: boolean }>`
  &:disabled {
    color: ${colors.black} !important;
  }
  padding: ${(props) => (props.hasLabelTop ? "18px 45px 0px 14px !important" : "")};
  ${dateInputStyles};
`;

export const DayPickerWrapper = styled.div`
  position: relative;
  display: flex;
  justify-content: flex-end;
  z-index: 20;

  ${breakpoints.smDown} {
    margin-left: 0;
    min-width: auto;
  }

  .rdp {
    --rdp-cell-size: 37px;
    --rdp-accent-color: ${colors.coral};
    --rdp-accent-color-dark: ${colors.coral};
    --rdp-background-color: ${colors.coralThin};
    /* Outline border for focused elements */
    --rdp-outline: 2px solid var(--rdp-accent-color);
    /* Outline border for focused and selected elements */
    --rdp-outline-selected: 2px solid rgba(0, 0, 0, 0.75);
    margin: auto;
  }
`;

export const DayPickerBackground = styled.div`
  position: absolute;
  background-color: ${colors.white};
  padding: 10px;
  width: 100%;
  box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.1);
  display: flex;
  justify-content: center;
  min-width: 300px;
  transform: translateY(-100%);
`;

export const DateInputFieldLabel = styled.div`
  position: absolute;
  top: 12px;
  left: 15px;
  font-size: 10px;
  font-family: ${fonts.fontBauMedium};
`;
